export { TrafficChangeIndicator, TrafficChangeIndicatorProps } from './TrafficChangeIndicator';
